// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"3f4909cc","313":"e7bf3577","322":"12e76364","326":"3b379587"}[chunkId] + ".chunk.js";
};